import { EmployeeApiResponseDto, EmployeeRequestDto } from '@personnel/application/dtos';
import { IEmployeeApiPort } from '@personnel/application/ports/IEmployeeApiPort';
import { errorAttributes, perLog } from '@personnel/application/observability';

export const getEmployeesUseCase = (props: { apiPort: IEmployeeApiPort }) => {
  const { apiPort } = props;

  const execute = async (request: EmployeeRequestDto): Promise<EmployeeApiResponseDto> => {
    const cleanedRequest = Object.fromEntries(
      Object.entries(request).filter(([, value]) => value !== null && value !== undefined && value !== ''),
    ) as EmployeeRequestDto;

    // Sorted so the same pair of states is always one value on the dashboard, whatever order the
    // administrator ticked the boxes in.
    const attributes = {
      'per.verificationStatusFilter': [...(request.verificationStatus ?? [])].sort().join(','),
      'per.page': request.page,
    };

    try {
      const employeeResponse = await apiPort.getEmployees(cleanedRequest);

      perLog.info('employeeListLoaded', { ...attributes, 'per.resultCount': employeeResponse.data.length });

      return employeeResponse;
    } catch (error) {
      perLog.error('employeeListLoaded', { ...attributes, ...errorAttributes(error) });
      throw error;
    }
  };

  return {
    execute,
  };
};
